let _ = require('lodash');

class EmailPreferences {
  constructor({
    id, customeremail, accountUpdate, latestFromBioguard, newsFromExpert, emailLanguagePreference, CASL,
  }) {
    this.id = id;
    this.customeremail = customeremail;
    this.accountUpdate = accountUpdate;
    this.latestFromBioguard = latestFromBioguard;
    this.newsFromExpert = newsFromExpert;
    this.emailLanguagePreference = emailLanguagePreference;
    this.CASL = CASL;
  }

  clone() {
    return _.cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      CustomerEmail: this.customeremail,
      AccountUpdate: this.accountUpdate,
      LatestFromBioguard: this.latestFromBioguard,
      NewsFromExpert: this.newsFromExpert,
      EmailLanguagePreference: this.emailLanguagePreference,
      CASL: this.CASL,
    };
  }

  static fromApiFormat(api) {
    return new EmailPreferences({
      id: api.ID,
      customeremail: api.CustomerEmail,
      accountUpdate: api.AccountUpdate,
      latestFromBioguard: api.LatestFromBioguard,
      newsFromExpert: api.NewsFromExpert,
      emailLanguagePreference: api.EmailLanguagePreference,
      CASL: api.CASL,
    });
  }
}

module.exports = EmailPreferences;
